import dao from '../../dao';

// initial state
const state = {
    authResult: null,
    leftPaneCollapsed: window.innerWidth < 1050
}

const getters = {
  isInitialized: () => dao.TOKEN !== '',
}

const actions = {
    // async authenticate({commit}) {
    // let authResult = await dao.authenticate()
    // commit('setAuthResult', authResult)
    // },
    openLeftPane({commit}) {
        commit('setLeftPaneCollapsed', false)
    },
    closeLeftPane({commit}) {
        commit('setLeftPaneCollapsed', true)
    },
    toggleLeftPane({commit, state}) {
        commit('setLeftPaneCollapsed', !state.leftPaneCollapsed)
    }
}

const mutations = {
    // setAuthResult(state, res) {
    // state.authResult = res
    // },
    setLeftPaneCollapsed(state, val) {
        state.leftPaneCollapsed = val
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
